export const PROCESS = 'Process';
//# sourceMappingURL=process.js.map